import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { Card } from "@mui/material";
import PageTitle from "../../../UI/PageTitle";
import { useHistory, useParams } from "react-router-dom";
import axios from "axios";
import { endpoints } from "../../../../services/apiurl";
import DownloadIcon from "@mui/icons-material/Download";
import { InfinitySpin } from "react-loader-spinner";
export default function MenuHistory() {
  let history = useHistory();
  let { restro_id } = useParams();
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  useEffect(() => {
    fetchData();
  }, []);
  const columns = [
    {
      name: "ID",

      selector: (row) => `Menu Label ${row.id}`,
    },
    {
      name: "Message",
      selector: (row) => {
        const message = row.msg || "N/A";
        const style = message.includes("error")
          ? { color: "darkorange" }
          : { color: "green" };

        return <span style={style}>{message}</span>;
      },
    },

    {
      name: "Created_At",
      selector: (row) => {
        const date = new Date(row.created_at);
        const formattedDate = `${date.getFullYear()}-${
          date.getMonth() + 1
        }-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
        return formattedDate;
      },
    },

    {
      name: "Download Excel",
      cell: (row) => (
        <DownloadIcon
          style={{
            cursor: "pointer",
            color: "#007BFF",
            fontSize: "30px",
          }}
          onClick={() => downloadExcel(row.id)}
        />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const downloadExcel = async (id) => {
    try {
      const response = await axios.post(
        endpoints.importExcelHistory,
        { id },
        {
          responseType: "blob",
        }
      );

      // Create a URL for the blob data
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `data.xlsx`); // Set the filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("There was an error downloading the file!", error);
    }
  };

  const fetchData = async () => {
    await axios
      .post(endpoints.importHistory, {
        restro_id: restro_id,
      })
      .then(
        (response) => {
          setIsLoaded(true);
          setItems(response.data.data);
        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      );
  };

  const handlePageChange = (page) => {
    fetchData(page, perPage);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);
  };

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!isLoaded) {
    return (
      <div>
        <div className="spinner">
          <InfinitySpin
            visible={true}
            width="200"
            color="#fbaa1a"
            ariaLabel="infinity-spin-loading"
          />
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <PageTitle title="Import Menu History" />

        <div className="App">
          <Card className="px-3 py-3">
            <DataTable
              columns={columns}
              data={items}
              pagination={false}
              // pagination
              // paginationServer
              paginationTotalRows={totalRows}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handlePerRowsChange}
            />
          </Card>
        </div>
      </div>
    );
  }
}
